import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Grid, Typography } from "@mui/material";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { RoutingLinks } from "../../utils/constants";
import { UserCommonStyles } from "../../styles/CommonStyles";

const TIPS = [
  "community_guidelines_1",
  "community_guidelines_2",
  "community_guidelines_3",
  "community_guidelines_4",
  "community_guidelines_5",
];

const CommunityGuidelines: React.FC = () => {
  const { t: translation } = useTranslation();
  const history = useHistory();
  const commonStyle = UserCommonStyles();

  const userLoggedIn = Boolean(localStorage.getItem("userData"));

  return (
    <Box>
      <Grid container>
        {userLoggedIn ? (
          <Grid item md={3}>
            <LeftSidebar />
          </Grid>
        ) : null}
        <Grid item md={userLoggedIn ? 9 : 12}>
          <Box className={`${commonStyle.p20} ${commonStyle.mt20}`} sx={{ maxWidth: 720 }}>
            <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
              {translation("community_guidelines")}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              {translation("community_guidelines_intro")}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 3 }}>
              {TIPS.map((key) => (
                <Typography component="li" key={key} sx={{ mb: 1.5, fontSize: 16, lineHeight: 1.5 }}>
                  {translation(key)}
                </Typography>
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              <Button
                variant="outlined"
                onClick={() => history.push("/acceptable-policy")}
                sx={{ textTransform: "none", borderColor: "#01B4BC", color: "#01B4BC", borderRadius: "10px" }}
              >
                {translation("Acceptable Use Policy")}
              </Button>
              <Button
                variant="contained"
                onClick={() => history.push(RoutingLinks.home)}
                sx={{ textTransform: "none", backgroundColor: "#01B4BC", borderRadius: "10px", "&:hover": { backgroundColor: "#019aa1" } }}
              >
                {translation("shorts_guidelines_got_it")}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CommunityGuidelines;
